/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */
import type {
  FacilityFlowCoreModulesCustomersDtosContactDto,
  FacilityFlowCoreModulesCustomersDtosCreateContactRequest,
  FacilityFlowCoreModulesCustomersDtosCreateContactResponse,
  FacilityFlowCoreModulesCustomersDtosSearchContactsResponse,
  FacilityFlowCoreModulesCustomersDtosUpdateContactRequest,
  FacilityFlowCoreModulesCustomersDtosUpdateContactResponse,
  GetApiV1ContactsParams
} from '.././models';

import { customInstance } from '../../mutator/custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getContacts = () => {
/**
 * @summary Create a new contact
 */
const postApiV1Contacts = (
    facilityFlowCoreModulesCustomersDtosCreateContactRequest: FacilityFlowCoreModulesCustomersDtosCreateContactRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesCustomersDtosCreateContactResponse>>,) => {
      return customInstance<FacilityFlowCoreModulesCustomersDtosCreateContactResponse>(
      {url: `/api/v1/contacts`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesCustomersDtosCreateContactRequest
    },
      options);
    }
  /**
 * @summary Search contacts with filtering and pagination
 */
const getApiV1Contacts = (
    params?: GetApiV1ContactsParams,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesCustomersDtosSearchContactsResponse>>,) => {
      return customInstance<FacilityFlowCoreModulesCustomersDtosSearchContactsResponse>(
      {url: `/api/v1/contacts`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Get contact by ID
 */
const getApiV1ContactsId = (
    id: string,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesCustomersDtosContactDto>>,) => {
      return customInstance<FacilityFlowCoreModulesCustomersDtosContactDto>(
      {url: `/api/v1/contacts/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Update an existing contact
 */
const putApiV1ContactsId = (
    id: string,
    facilityFlowCoreModulesCustomersDtosUpdateContactRequest: FacilityFlowCoreModulesCustomersDtosUpdateContactRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesCustomersDtosUpdateContactResponse>>,) => {
      return customInstance<FacilityFlowCoreModulesCustomersDtosUpdateContactResponse>(
      {url: `/api/v1/contacts/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesCustomersDtosUpdateContactRequest
    },
      options);
    }
  /**
 * @summary Delete a contact
 */
const deleteApiV1ContactsId = (
    id: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/contacts/${id}`, method: 'DELETE'
    },
      options);
    }
  return {postApiV1Contacts,getApiV1Contacts,getApiV1ContactsId,putApiV1ContactsId,deleteApiV1ContactsId}};
export type PostApiV1ContactsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getContacts>['postApiV1Contacts']>>>
export type GetApiV1ContactsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getContacts>['getApiV1Contacts']>>>
export type GetApiV1ContactsIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getContacts>['getApiV1ContactsId']>>>
export type PutApiV1ContactsIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getContacts>['putApiV1ContactsId']>>>
export type DeleteApiV1ContactsIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getContacts>['deleteApiV1ContactsId']>>>
